"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCSSFunctions = void 0;
const parseCSSFunction_1 = require("./parseCSSFunction");
const cssFunctionRegexp = /(?<name>[\w-]+)\((?<value>.*?)\)/gm;
function parseCSSFunctions(value) {
    var _a;
    return (((_a = value
        .trim()
        .match(cssFunctionRegexp)) === null || _a === void 0 ? void 0 : _a.map((cssFunction) => {
        return (0, parseCSSFunction_1.parseCSSFunction)(cssFunction);
    })) || []);
}
exports.parseCSSFunctions = parseCSSFunctions;
